import {
  adminTableData,
  adminTableHead,
  leadTableHead,
} from "@assets/mocks/tableData";
import Iconify from "@components/iconify";
import Table from "@components/Table";
import { Button } from "@components/ui/button";
import * as Select from "@radix-ui/react-select";
import UserTableToolbar from "@components/user-table-toolbar";
import ReactPaginate from "react-paginate";
import {
  Checkbox,
  IconButton,
  MenuItem,
  Popover,
  TableCell,
} from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import SearchInput from "@components/ui/searchInput";
import { useNavigate } from "react-router";
import { Campaign } from "@redux/slices/campaign";
import axios from "axios";
import LoadingScreen from "@components/LoadingScreen";

interface TableData {
  name: string;
  [key: string]: any;
}

const Leads: React.FC = () => {
  const [selected, setSelected] = useState<string[]>([]);
  const [itemOffset, setItemOffset] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10); // State for items per page
  const [openMenu, setOpenMenu] = React.useState(null);
  let pathname = window.location.pathname.split("/")[2];
  let filteredData: TableData[];

  const [campaignData, setCampaignData] = useState<Campaign[]>([]);
  const [hotLeads, setHotLeads] = useState<Campaign[]>([]);
  const [coldLeads, setColdLeads] = useState<Campaign[]>([]);
  const [warmLeads, setWarmLeads] = useState<Campaign[]>([]);
  const [selectedStatus, setSelectedStatus] = useState<string>("Running");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    const fetchCampaignsStats = async () => {
      try {
        const response = await axios.get(
          "https://aquisize-backend-zrj2.onrender.com/api/running-campaigns"
        );
        setCampaignData(response.data);
        if (response.data.length > 0) {
          const HotLeads1: any = [];
          const WarmLeads1: any = [];
          const ColdLeads1: any = [];
  
           response.data.forEach((campaign:any) => {
            campaign.stats[0].stats.emails.forEach((email: any) => {
              if (email.reply > 0) {
                HotLeads1.push({
                  email: email,
                  campaign: campaign.name,
                  status: campaign.status,
                });
              } else if (email.open > 0 && email.reply < 1) {
                WarmLeads1.push({
                  email: email,
                  campaign: campaign.name,
                  status: campaign.status,
                });
              } else if (email.open < 1 && email.reply < 1) {
                ColdLeads1.push({
                  email: email,
                  campaign: campaign.name,
                  status: campaign.status,
                });
              }
            });
          });
  
          setHotLeads(HotLeads1);
          setWarmLeads(WarmLeads1);
          setColdLeads(ColdLeads1);
        }
         setLoading(false);
      } catch (err) {
        setLoading(false);
        console.error("Error fetching campaign stats:", err);
      }
    };

    fetchCampaignsStats();
  }, []);

  // useEffect(() => {
  //   setLoading(true);
  //     if (campaignData.length > 0) {
  //       const HotLeads1: any = [];
  //       const WarmLeads1: any = [];
  //       const ColdLeads1: any = [];

  //        campaignData.forEach((campaign) => {
  //         campaign.stats[0].stats.emails.forEach((email: any) => {
  //           if (email.reply > 0) {
  //             HotLeads1.push({
  //               email: email,
  //               campaign: campaign.name,
  //               status: campaign.status,
  //             });
  //           } else if (email.open > 0 && email.reply < 1) {
  //             WarmLeads1.push({
  //               email: email,
  //               campaign: campaign.name,
  //               status: campaign.status,
  //             });
  //           } else if (email.open < 1 && email.reply < 1) {
  //             ColdLeads1.push({
  //               email: email,
  //               campaign: campaign.name,
  //               status: campaign.status,
  //             });
  //           }
  //         });
  //       });

  //       setHotLeads(HotLeads1);
  //       setWarmLeads(WarmLeads1);
  //       setColdLeads(ColdLeads1);
  //     }
  //   setLoading(false);
  // }, [campaignData]);

  const data =
    pathname === "hotleads"
      ? hotLeads
      : pathname === "coldleads"
      ? coldLeads
      : warmLeads;

  const endOffset = itemOffset + itemsPerPage;
  filteredData = data.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const handlePageClick = (event: { selected: number }) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  const handleLeadsChange = (value: string) => {
    navigate(`/leads/${value}`);
  };

  const handleItemsPerPageChange = (value: string) => {
    setItemsPerPage(parseInt(value, 10));
    setItemOffset(0);
  };

  return (
    <div>
      {loading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="md:flex justify-between items-center mt-7">
            <h2 className="text-gray font-bold sm:text-[22px] text-lg capitalize md:mb-0 mb-4">
              {pathname.split("/")[0]=="coldleads"? pathname.split("/")[0].split("l")[0]+"l"+pathname.split("/")[0].split("l")[1]:pathname.split("/")[0].split("l")[0]} Leads
            </h2>
            <div className="sm:flex items-center">
              <div className="sm:me-2 sm:w-52 sm:mb-0 mb-3">
                <Select.Root value={pathname} onValueChange={handleLeadsChange}>
                  <SelectTrigger
                    className="SelectTrigger bg-white border-none"
                    aria-label="Leads"
                  >
                    <SelectValue
                      className="placeholder:capitalize"
                      placeholder="Select Leads"
                    />
                  </SelectTrigger>
                  <SelectContent className="SelectContent">
                    <SelectItem value="hotleads">
                      Hot Leads ({hotLeads?.length})
                    </SelectItem>
                    <SelectItem value="coldleads">
                      Cold Leads ({coldLeads?.length})
                    </SelectItem>
                    <SelectItem value="warmleads">
                      Warm Leads ({warmLeads?.length})
                    </SelectItem>
                  </SelectContent>
                </Select.Root>
              </div>
              <div>
                <SearchInput />
              </div>
            </div>
          </div>
          <Table textIndex={3} tableHead={leadTableHead}>
            {filteredData?.map((val, index) => (
              <tr
                key={index}
                className="text-sm text-[#71717A] text-center border-b last:border-0 border-[#EAECF0]"
              >
                <td className="p-5 text-left">
                  <span className="text-[#3F3F46]"> {val.email.subject}</span>
                </td>
                <td className="p-5 text-left text-lime-600">
                  <span className="uppercase text-[#3F3F46]">
                    {val.campaign}
                  </span>
                  <br />
                </td>
                {/* <td className="p-5 text-left">
                  <span className="text-[#3F3F46]">New reply received</span>
                  <br />3 days ago
                </td> */}
                <td className="p-5 text-left text-lime-700 font-medium">
                  {val.status}
                </td>
              </tr>
            ))}
          </Table>
          <div className="flex flex-col md:flex-row justify-between items-center mt-8 pb-32">
            <div className="me-2 w-32 md:mb-0 mb-4">
              <Select.Root onValueChange={handleItemsPerPageChange}>
                <SelectTrigger className="SelectTrigger bg-white border-none">
                  <SelectValue placeholder={`${itemsPerPage} per Page`} />
                </SelectTrigger>
                <SelectContent className="SelectContent">
                  <SelectItem value="10">10 per page</SelectItem>
                  <SelectItem value="15">15 per page</SelectItem>
                  <SelectItem value="20">20 per page</SelectItem>
                </SelectContent>
              </Select.Root>
            </div>
            <div className="pagination">
              <ReactPaginate
                breakLabel="..."
                nextLabel={window.innerWidth > 576 ? "Next  →" : ">"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel={window.innerWidth > 576 ? "←  Prev" : "<"}
                renderOnZeroPageCount={null}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Leads;
